import React, {Fragment} from "react";

// components
import SellersGrid from "./SellersGrid";
import HeaderActions from "../../Navigation/HeaderActions";
import {CompositeFilterDescriptor} from "@progress/kendo-data-query";

interface Props {
  tableData: any[];
  fetchingSellerStats: boolean;
  exportButton: () => JSX.Element;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  activeFilters: CompositeFilterDescriptor
  featuresAllowed: string[];
}

export default (props: Props) => {

  return (
    <Fragment>
      <HeaderActions>
        {props.exportButton()}
      </HeaderActions>
      <SellersGrid
        tableData={props.tableData}
        loading={props.fetchingSellerStats}
        requestNewPage={props.sendFilters}
        take={props.take}
        skip={props.skip}
        total={props.total}
        activeFilters={props.activeFilters}
        featuresAllowed={props.featuresAllowed}
      />
    </Fragment>
  );
};
